import request from '../../../shared/request'

export function getJobSiteServiceOrders(job_id) {
  return request(`/job/job_site_service_orders/${job_id}/`)
}

export function getJobSiteServiceOrderItems(service_order_id) {
  return request(`/job/job_site_service_orders/${service_order_id}/items`)
}

export function createServiceOrder(payload) {
  return request(`/job/job_site_service_orders/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateServiceOrder(payload) {
  return request(`/job/job_site_service_orders/${payload.service_order_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteServiceOrder(payload) {
  return request(`/job/job_site_service_orders/${payload.service_order_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function markTaskComplete(task_id) {
  return request(`/job/job_site_service_orders/${task_id}/task_complete`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function quickAddTask(payload) {
  return request(`/tasks/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteServiceOrders.js